import { render, staticRenderFns } from "./RootCauseBar.vue?vue&type=template&id=6e21880e&"
import script from "./RootCauseBar.vue?vue&type=script&lang=js&"
export * from "./RootCauseBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports